export default {
  data: function data() {
    return {
      itemList: [{
        value: '9',
        label: '灵石*200000'
      }, {
        value: '8',
        label: '灵晶*200'
      }, {
        value: '6',
        label: '祈福灵匙*10'
      }, {
        value: '5',
        label: '周边抱枕'
      }, {
        value: '3',
        label: '68元代金券'
      }, {
        value: '2',
        label: '128元代金券'
      }, {
        value: '1',
        label: '198元代金券'
      }, {
        value: '7',
        label: '灵宠蛋*20'
      }, {
        value: '4',
        label: '纪念/实体剑'
      }],
      dailyWelFareitemList: [{
        value: '1',
        label: '月卡'
      }, {
        value: '2',
        label: '灵晶*200'
      }, {
        value: '3',
        label: '祈福宝匙*3'
      }, {
        value: '8',
        label: '祈福灵匙*10'
      }, {
        value: '4',
        label: '星尘*6'
      }, {
        value: '7',
        label: '星移令*100'
      }, {
        value: '6',
        label: '灵石*200000'
      }, {
        value: '5',
        label: '灵宠蛋*20'
      }]
    };
  },
  activated: function activated() {},
  created: function created() {},
  methods: {}
};